import { render, staticRenderFns } from "./mchPermission.vue?vue&type=template&id=4d94725c&scoped=true&"
import script from "./mchPermission.vue?vue&type=script&lang=js&"
export * from "./mchPermission.vue?vue&type=script&lang=js&"
import style0 from "./mchPermission.vue?vue&type=style&index=0&id=4d94725c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d94725c",
  null
  
)

export default component.exports